import { createSlice } from "@reduxjs/toolkit";
import { logger } from "../utils/logger";
const initialState = {
	isAuthenticated: false,
	isLoading: true,
	profile: null,
	isProfile: false,
	globalData: null,
	authData: null,
	profileData: null,
	coordinates: null,
};
export const globalSlice = createSlice({
	name: "global",
	initialState: initialState,
	reducers: {
		setAuthentication: (state, action) => {
			state.isAuthenticated = action.payload;
			state.isLoading = false;
		},
		setGlobalData: (state, action) => {
			// state.isLoading = false;
			state.globalData = action.payload;
		},
		setAuthData: (state, action) => {
			state.isAuthenticated = true;
			state.authData = action.payload;
		},
		setProfleData: (state, action) => {
			state.isProfile = true;
			state.profileData = action.payload;
		},
		setCoordinates: (state, action) => {
			state.coordinates = action.payload;
		},

		logOut: () => initialState,
	},
});

export const {
	setAuthentication,
	setGlobalData,
	setAuthData,
	setProfleData,
	setCoordinates,
	logOut,
} = globalSlice.actions;

export default globalSlice.reducer;
